import { observer } from 'mobx-react';
import React from 'react'
import { ReactComponent as Check } from '../../svg/check.svg'

@observer
class ColorBlock extends React.Component {

  render(){
    const { colors, title, selected, onClick, objName, titleStyle } = this.props
    return (
      <>
        <div className='color-block-title-wrapper' style={titleStyle ? titleStyle : {}}>
          <h5 className='color-block-title'>{title}</h5>
        </div>
        <div className='color-block'>
          {
            colors.map((color, idx) => (
              <div key={color.color + idx + objName} className='color-block__wrapper'>
                <div 
                  onClick={() => onClick(color.color, objName)}
                  className={color.selected ? 'color-block__color active' : 'color-block__color'} 
                  style={{backgroundColor: color.color}} 
                />
                {
                  color.selected ? (
                    <Check className='color-check'/>
                  )
                  :
                  undefined
                }
              </div>
            ))
          }
        </div>
      </>
    )
  }

}

export default ColorBlock